export const TOPICS_OPTIONS = [
  {
    title: '🫂 Support and acceptance',
    id: 'supportive',
  },
  {
    title: '❤️ Flirting and love',
    id: 'romantic',
  },
  {
    title: '💬 Intelligent conversations',
    id: 'storyteller',
  },
  {
    title: '🎭 Roleplay',
    id: 'dating',
  },
  {
    title: '🧠 Exploring AI capabilities',
    id: 'fun',
  },
];
